(function () {
  let swiperCardSlider,
    scrollbarSettings = {
      slidesPerView: 2,
      spaceBetween: 16,
      mousewheel: {
        forceToAxis: true,
      },
      speed: 400,
      allowTouchMove: true,
      breakpoints: {
        990: {
          slidesPerView: 3,
        },
        1800: {
          slidesPerView: 4,
        },
      },
    },
    sliderSettings = {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 800,
      allowTouchMove: true,
    };

  const initSlider = (section, settings) => {
    if (!section || !section.classList.contains("card-slider-section")) return;

    const sliderContainer = section.querySelector(".card-slider");
    if (!sliderContainer) return;

    // Scrollbar colors are now handled in the Liquid template
    // No need to set CSS custom properties here

    const swiperEl = section.querySelector(".card-slider__layout");
    const swiperWrapper = section.querySelector(".card-slider__list");
    const slides = section.querySelectorAll(".card-slider__item");
    const freemode = JSON.parse(sliderContainer.dataset.freeMode.toLowerCase());

    // Get dynamic slides per view values from section settings
    const slidesMobile = parseFloat(sliderContainer.dataset.slidesMobile) || 1.0;
    const slidesTablet = parseFloat(sliderContainer.dataset.slidesTablet) || 2.0;
    const slidesDesktop = parseFloat(sliderContainer.dataset.slidesDesktop) || 3.0;
    const slidesLarge = parseFloat(sliderContainer.dataset.slidesLarge) || 4.0;

    if (!swiperEl || !swiperWrapper || !slides || !slides.length) return;

    const mobSlidesPreView = swiperEl.classList.contains("card-slider__layout--visible-overflow")
      ? "auto"
      : slidesMobile;

    swiperEl.classList.add("swiper");
    swiperWrapper.classList.add("swiper-wrapper");
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    const progressBar = section.querySelector(".swiper-scrollbar");
    const nextBtn = section.querySelector(".card-slider__nav-button--next");
    const prevBtn = section.querySelector(".card-slider__nav-button--prev");
    const navButtons = section.querySelector(".card-slider__navigation-buttons");

    const baseScrollbarSettings = {
      ...scrollbarSettings,
      slidesPerView: slidesMobile,
      breakpoints: {
        576: {
          slidesPerView: slidesTablet,
        },
        990: {
          slidesPerView: slidesDesktop,
        },
        1800: {
          slidesPerView: slidesLarge,
        },
      },
      scrollbar: {
        el: progressBar,
        grabCursor: true,
        draggable: true,
        hide: false,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
    };

    const baseSliderSettings = {
      ...sliderSettings,
      freeMode: freemode,
      slidesPerView: slidesMobile,
      breakpoints: {
        576: {
          slidesPerView: slidesTablet,
        },
        990: {
          slidesPerView: slidesDesktop,
        },
        1800: {
          slidesPerView: slidesLarge,
        },
      },
      pagination: {
        el: section.querySelector(".card-slider__pagination"),
        clickable: true,
        bulletClass: "card-slider__pagination-bullet",
        bulletActiveClass: "card-slider__pagination-bullet--active",
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
    };

    swiperCardSlider = new Swiper(swiperEl, settings === "bar" ? baseScrollbarSettings : baseSliderSettings);

    if (settings === "bar" && navButtons) {
      const checkScrollbarVisibility = () => {
        if (progressBar && swiperCardSlider) {
          const scrollbarEl = swiperCardSlider.scrollbar?.el;
          if (scrollbarEl) {
            const isScrollbarVisible = scrollbarEl.offsetWidth > 0 && scrollbarEl.offsetHeight > 0;
            navButtons.style.display = isScrollbarVisible ? "flex" : "none";
          }
        }
      };

      setTimeout(checkScrollbarVisibility, 100);
      swiperCardSlider.on("resize", checkScrollbarVisibility);
      swiperCardSlider.on("slideChange", checkScrollbarVisibility);
    }
  };

  const destroySlider = (section) => {
    if (!swiperCardSlider || !section) return;

    const slides = section.querySelectorAll(".card-slider__item");
    const swiperEl = section.querySelector(".card-slider__layout");
    const swiperWrapper = section.querySelector(".card-slider__list");

    if (!swiperEl || !slides || !slides.length || !swiperWrapper) return;

    swiperCardSlider.destroy(true, true);
    swiperCardSlider = null;

    swiperEl.classList.remove("swiper");
    swiperWrapper.classList.remove("swiper-wrapper");
    slides.forEach((slide) => slide.classList.remove("swiper-slide"));
  };

  const initPopularProducts = (section) => {
    if (!section || !section.classList.contains("card-slider-section")) return;

    const sliderContainer = section.querySelector(".card-slider");
    const cardsLayout = sliderContainer.dataset.layout || "grid";
    const cardsMobileLayout = sliderContainer.dataset.layoutMobile || "column";

    let currentLayout = null;

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      let newLayout;

      if (entry.contentRect.width < 576) {
        newLayout = cardsMobileLayout === "slider" ? "slider" : "column";
      } else {
        newLayout = cardsLayout === "bar" ? "bar" : "grid";
      }

      if (newLayout !== currentLayout) {
        currentLayout = newLayout;

        if (swiperCardSlider) {
          destroySlider(section);
        }

        if (newLayout === "slider" || newLayout === "bar") {
          initSlider(section, newLayout);
        }
      }
    });

    sectionResizeObserver.observe(section);

    // Initialize video play buttons
    initVideoControls(section);
  };

  const animateProductCards = (section) => {
    if (!section || !section.classList.contains("card-slider-section") || !section.querySelector(".animate-on-scroll")) {
      return;
    }

    const popularProductsLayout = section.querySelector(".card-slider__layout");
    if (!popularProductsLayout) return;

    ScrollTrigger.create({
      trigger: popularProductsLayout,
      start: "20% bottom",
      end: "bottom top",
      onEnter: () => popularProductsLayout.classList.add("animated"),
    });
  };

  const initVideoControls = (section) => {
    if (!section || !section.classList.contains("card-slider-section")) return;
    const videoWrappers = section.querySelectorAll(".card-slider__video-wrapper");

    videoWrappers.forEach((wrapper) => {
      if (wrapper.dataset.controlsInitialized === "true") return;

      const video = wrapper.querySelector("video");
      const toggleButton = wrapper.querySelector(".card-slider__play-button");

      if (!video || !toggleButton) return;

      wrapper.dataset.controlsInitialized = "true";

      const updateState = () => {
        const isPlaying = !video.paused && !video.ended;
        wrapper.classList.toggle("is-playing", isPlaying);
        toggleButton.setAttribute("aria-label", isPlaying ? "Pause video" : "Play video");
      };

      const playVideo = () => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }
      };

      const pauseVideo = () => {
        video.pause();
      };

      const togglePlayback = () => {
        if (video.paused || video.ended) {
          playVideo();
          return;
        }

        pauseVideo();
      };

      toggleButton.addEventListener("click", (event) => {
        event.stopPropagation();
        togglePlayback();
      });

      wrapper.addEventListener("click", (event) => {
        if (event.target.closest(".card-slider__play-button")) return;
        togglePlayback();
      });

      video.addEventListener("play", updateState);
      video.addEventListener("pause", updateState);
      video.addEventListener("ended", updateState);

      updateState();
    });
  };

  // Initial run
  initPopularProducts(document.currentScript.parentElement);
  animateProductCards(document.currentScript.parentElement);

  // Section load events
  document.addEventListener("shopify:section:load", function (event) {
    initPopularProducts(event.target);
    animateProductCards(event.target);
  });
})();
